(function () {
  if (window.matchMedia('(pointer: coarse)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sprout = document.getElementById('pp-sprout');
  if (!sprout) return;

  var hoverSelector = 'a, button, .pp-btn, .button, input[type="submit"], [role="button"]';
  var visible = false;

  function moveTo(x, y) {
    sprout.style.left = x + 'px';
    sprout.style.top = y + 'px';
  }

  function onOver(e) {
    var target = e.target.closest && e.target.closest(hoverSelector);
    if (!target || visible) return;
    visible = true;
    sprout.style.setProperty('--pp-sprout-rot', (Math.random() * 20 - 10).toFixed(1) + 'deg');
    moveTo(e.clientX, e.clientY);
    sprout.classList.add('is-visible');
  }

  function onOut(e) {
    var target = e.target.closest && e.target.closest(hoverSelector);
    if (!target) return;
    if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest(hoverSelector) === target) return;
    visible = false;
    sprout.classList.remove('is-visible');
  }

  function onMove(e) {
    if (visible) moveTo(e.clientX, e.clientY);
  }

  document.addEventListener('mouseover', onOver, { passive: true });
  document.addEventListener('mouseout', onOut, { passive: true });
  document.addEventListener('mousemove', onMove, { passive: true });
})();
